import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { LoaderRow } from "@circle-react/components/shared/LoaderRow";
import { PaginationButton } from "@circle-react/components/shared/PaginationButton";
import { Typography } from "@circle-react-uikit/Typography";
import { CommentItem } from "./CommentItem";
import { useComments } from "./useComments";

export const Comments = ({ space }) => {
  const {
    records: comments,
    isLoading,
    perPage,
    page,
    totalCount,
    loadPage,
    refetch,
  } = useComments({ space });
  if (isLoading) {
    return <LoaderRow />;
  }

  const start = Math.min(totalCount, (page - 1) * perPage + 1);
  const end = Math.min(totalCount, page * perPage);

  if (totalCount == 0) {
    return (
      <div className="mx-auto h-full max-w-lg py-10">
        <div className="text-dark mb-1 text-center md:mb-4">
          <Typography.TitleMd as="h4" weight="semibold">
            {I18n.t("courses.admin_summary.comments_empty.title")}
          </Typography.TitleMd>
          <div>
            <Typography.BodySm weight="medium">
              {I18n.t("courses.admin_summary.comments_empty.description")}
            </Typography.BodySm>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h3 className="pt-2">
        <Typography.LabelMd weight="medium">
          {t("courses.admin_summary.comments_count", { count: totalCount })}
        </Typography.LabelMd>
      </h3>
      {comments?.map(comment => (
        <CommentItem
          key={comment.id}
          comment={comment}
          space={space}
          refetch={refetch}
        />
      ))}
      <div className="border-primary flex w-full items-center justify-between border-t pt-2">
        <div>
          <Typography.LabelSm>
            {t("data_table_footer_pagination.showing")}
            <Typography.LabelSm weight="bold">
              {start}-{end}
            </Typography.LabelSm>
            {t("data_table_footer_pagination.of")}
            <Typography.LabelSm weight="bold">
              {totalCount ?? 0}
            </Typography.LabelSm>{" "}
            {t("courses.admin_summary.comments")}
          </Typography.LabelSm>
        </div>
        <PaginationButton
          totalPages={Math.ceil(totalCount / perPage)}
          onClick={loadPage}
          defaultPage={page}
        />
      </div>
    </div>
  );
};

Comments.propTypes = {
  space: PropTypes.object,
};
